var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stripe-wallet-widget-page"},[_c('div',{staticClass:"app-content-page"},[_c('app-stripe-wallet-widget-filter'),_c('app-stripe-wallet-widget')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }